import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../Styles/Sidebar.css";
import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupIcon from "@mui/icons-material/Group";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import ViewListIcon from "@mui/icons-material/ViewList";
import LogoutIcon from "@mui/icons-material/Logout";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ScheduleIcon from "@mui/icons-material/Schedule";
import DateRangeIcon from "@mui/icons-material/DateRange";
import EventIcon from "@mui/icons-material/Event";
import WorkIcon from "@mui/icons-material/Work";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import ForumIcon from "@mui/icons-material/Forum";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import ClassIcon from "@mui/icons-material/Class";
import SchoolIcon from "@mui/icons-material/School";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AnnouncementIcon from "@mui/icons-material/Announcement";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import HistoryIcon from "@mui/icons-material/History";
// import ListAltIcon from "@mui/icons-material/ListAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import HotelIcon from "@mui/icons-material/Hotel";
import axios from "axios";

function Sidebar() {
  const [isUserManagementOpen, setIsUserManagementOpen] = useState(false);
  const [isUserManagementAdminOpen, setIsUserManagementAdminOpen] =
    useState(false);
  const [isSubscriptionPlansOpen, setIsSubscriptionPlansOpen] = useState(false);
  const [isLeaveManagementOpen, setIsLeaveManagementOpen] = useState(false);
  const [isEventsAnnouncementsOpen, setIsEventsAnnouncementsOpen] =
    useState(false);
  const [isFacultyAttendanceOpen, setIsFacultyAttendanceOpen] = useState(false);
  const [isStudentemsOpen, setIsStudentemsOpen] = useState(false);
  const [isAttendanceOpen, setIsAttendanceOpen] = useState(false);
  const [isAdditionalOpen, setIsAdditionalOpen] = useState(false);
  const [isMangeLeaveOpen, setIsMangeLeaveOpen] = useState(false);
  const [isStudentLeaveOpen, setIsStudentLeaveOpen] = useState(false);
  const [isStudentLeavesOpen, setIsStudentLeavesOpen] = useState(false);
  const [isExamOpen, setIsExamOpen] = useState(false);
  const [isPayrollOpen, setIsPayrollOpen] = useState(false);
  const [isHostelOpen, setIsHostelOpen] = useState(false);
  const [isEmsOpen, setIsEmsOpen] = useState(false);
  const [role, setRole] = useState(null);
  const [hasHostelAccess, setHasHostelAccess] = useState(false);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const storedRole = localStorage.getItem("userRole");
    setRole(storedRole);
    // Fetch user profile to get necessary data
    const fetchUserProfile = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await axios.get("https://api.uniums.com/api/profile", {
          headers: { Authorization: `Bearer ${token}` },
        });

        const userData = response.data;

        // For admin users, check if they have hostel access directly
        if (userData.role === "admin") {
          checkHostelAccess(userData._id);
        }
        // For students, check if their admin has hostel access
        else if (userData.role === "student" && userData.adminId) {
          checkHostelAccess(userData.adminId);
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };

    fetchUserProfile();
  }, []);

  // Function to check hostel access
  const checkHostelAccess = async (adminId) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.get(
        `https://api.uniums.com/api/User/hostel-access/check/${adminId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success && response.data.hasAccess) {
        setHasHostelAccess(true);
      }
    } catch (error) {
      console.error("Error checking hostel access:", error);
    }
  };

  const toggleDropdown = (dropdownType) => {
    if (dropdownType === "userManagement") {
      setIsUserManagementOpen(!isUserManagementOpen);
    } else if (dropdownType === "subscriptionPlans") {
      setIsSubscriptionPlansOpen(!isSubscriptionPlansOpen);
    } else if (dropdownType === "userManagementAdmin") {
      setIsUserManagementAdminOpen(!isUserManagementAdminOpen);
    } else if (dropdownType === "leaveManagement") {
      setIsLeaveManagementOpen(!isLeaveManagementOpen);
    } else if (dropdownType === "enventsannouncements") {
      setIsEventsAnnouncementsOpen(!isEventsAnnouncementsOpen);
    } else if (dropdownType === "Attendance") {
      setIsAttendanceOpen(!isAttendanceOpen);
    } else if (dropdownType === "Additional") {
      setIsAdditionalOpen(!isAdditionalOpen);
    } else if (dropdownType === "Facultyattendance") {
      setIsFacultyAttendanceOpen(!isFacultyAttendanceOpen);
    } else if (dropdownType === "Ems") {
      setIsEmsOpen(!isEmsOpen);
    } else if (dropdownType === "MangeLeave") {
      setIsMangeLeaveOpen(!isMangeLeaveOpen);
    } else if (dropdownType === "studentems") {
      setIsStudentemsOpen(!isStudentemsOpen);
    } else if (dropdownType === "Studentleaves") {
      setIsStudentLeaveOpen(!isStudentLeaveOpen);
    } else if (dropdownType === "studentLeaves") {
      setIsStudentLeavesOpen(!isStudentLeavesOpen);
    } else if (dropdownType === "examsystem") {
      setIsExamOpen(!isExamOpen);
    } else if (dropdownType === "payroll") {
      setIsPayrollOpen(!isPayrollOpen);
    } else if (dropdownType === "hostelServices") {
      setIsHostelOpen(!isHostelOpen);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userRole");
    navigate("/");
  };

  const renderSidebarContent = () => {
    if (role === "super admin") {
      return (
        <>
          <li style={{ marginTop: "0px" }}>
            <Link to="/superadmin">
              <DashboardIcon />
              <span>Dashboard</span>
            </Link>
          </li>
          <li>
            <div
              onClick={() => toggleDropdown("userManagement")}
              className="dropdown-toggle"
            >
              <GroupIcon />
              <span>User Management</span>
              {isUserManagementOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </div>
            {isUserManagementOpen && (
              <ul className="dropdown-menu">
                <li>
                  <Link to="/create-admin">
                    <GroupIcon />
                    <span>Create Admin</span>
                  </Link>
                </li>
                <li>
                  <Link to="/Manage-users">
                    <PersonSearchIcon />
                    <span>Manage Admin</span>
                  </Link>
                </li>
                <li>
                  <Link to="/deactivate-users">
                    <PersonSearchIcon />
                    <span>Deactivate Admin</span>
                  </Link>
                </li>
                <li>
                  <Link to="/active-users">
                    <VisibilityIcon />
                    <span>Active Admin</span>
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <div
              onClick={() => toggleDropdown("subscriptionPlans")}
              className="dropdown-toggle"
            >
              <SubscriptionsIcon />
              <span>Subscription Plans</span>
              {isSubscriptionPlansOpen ? (
                <ExpandLessIcon />
              ) : (
                <ExpandMoreIcon />
              )}
            </div>
            {isSubscriptionPlansOpen && (
              <ul className="dropdown-menu">
                <li>
                  <Link to="/plans">
                    <ViewListIcon />
                    <span>View Plans</span>
                  </Link>
                </li>
                <li>
                  <Link to="/de-active-plan">
                    <EventBusyIcon />
                    <span>Expair Plans</span>
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <Link to="/admin-details">
              <AdminPanelSettingsIcon />
              <span>Admin Details</span>
            </Link>
          </li>
          <li>
            <Link to="/hostel-service">
              <HotelIcon />
              <span>Hostel Service</span>
            </Link>
          </li>
          <li>
            <Link to="/reports">
              <ShowChartIcon />
              <span>Reports</span>
            </Link>
          </li>
        </>
      );
    }

    if (role === "admin") {
      return (
        <>
          <li style={{ marginTop: "0px" }}>
            <Link to="/admin">
              <DashboardIcon />
              <span>Dashboard</span>
            </Link>
          </li>
          <li>
            <div
              onClick={() => toggleDropdown("userManagementAdmin")}
              className="dropdown-toggle"
            >
              <GroupIcon />
              <span>User Management</span>
              {isUserManagementAdminOpen ? (
                <ExpandLessIcon />
              ) : (
                <ExpandMoreIcon />
              )}
            </div>
            {isUserManagementAdminOpen && (
              <ul className="dropdown-menu">
                <li>
                  <Link to="/create-user">
                    <GroupIcon />
                    <span>Create User</span>
                  </Link>
                </li>
                <li>
                  <Link to="/manage-users-admin">
                    <GroupIcon />
                    <span>Manage Users</span>
                  </Link>
                </li>
                <li>
                  <Link to="/view-faculty">
                    <GroupIcon />
                    <span>View Faculty</span>
                  </Link>
                </li>
                <li>
                  <Link to="/view-students">
                    <VisibilityIcon />
                    <span>View Students</span>
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <div
              onClick={() => toggleDropdown("Attendance")}
              className="dropdown-toggle"
            >
              <EventAvailableIcon />
              <span>Attendance</span>
              {isAttendanceOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </div>
            {isAttendanceOpen && (
              <ul className="dropdown-menu">
                <li>
                  <Link to="/faculty-attendance">
                    <CheckCircleIcon />
                    <span>Faculty Attendance</span>
                  </Link>
                </li>
                <li>
                  <Link to="/faculty-attendance-today">
                    <HistoryIcon />
                    <span>View Today</span>
                  </Link>
                </li>
                <li>
                  <Link to="/attendance-history">
                    <HowToRegIcon />
                    <span>Attendance History</span>
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <div
              onClick={() => toggleDropdown("Additional")}
              className="dropdown-toggle"
            >
              <EventAvailableIcon />
              <span>Additional Updates</span>
              {isAdditionalOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </div>
            {isAdditionalOpen && (
              <ul className="dropdown-menu">
                <li>
                  <Link to="/Add-classes-subjects">
                    <WorkIcon />
                    <span>Subjects & Classes</span>
                  </Link>
                </li>

                <li>
                  <Link to="/update-faculty">
                    <GroupIcon />
                    <span>Updates Faculty</span>
                  </Link>
                </li>
                <li>
                  <Link to="/update-students">
                    <HowToRegIcon />
                    <span>Update Students</span>
                  </Link>
                </li>
                <li>
                  <Link to="/Edit-classes-subjects">
                    <AccessTimeIcon />
                    <span> Edit Subject Classes</span>
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <div
              onClick={() => toggleDropdown("leaveManagement")}
              className="dropdown-toggle"
            >
              <CalendarTodayIcon />
              <span>Leave Management</span>
              {isLeaveManagementOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </div>
            {isLeaveManagementOpen && (
              <ul className="dropdown-menu">
                <li>
                  <Link to="/leave-request">
                    <DateRangeIcon />
                    <span>Leave Request</span>
                  </Link>
                </li>
                <li>
                  <Link to="/today-leave-apply">
                    <ScheduleIcon />
                    <span>Today's Leaves</span>
                  </Link>
                </li>
                <li>
                  <Link to="/all-leave-history">
                    <EventIcon />
                    <span>Leave History</span>
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <div
              onClick={() => toggleDropdown("enventsannouncements")}
              className="dropdown-toggle"
            >
              <EventAvailableIcon />
              <span> Announcements</span>
              {isEventsAnnouncementsOpen ? (
                <ExpandLessIcon />
              ) : (
                <ExpandMoreIcon />
              )}
            </div>
            {isEventsAnnouncementsOpen && (
              <ul className="dropdown-menu">
                <li>
                  <Link to="/create-events-annoucements">
                    <ForumIcon />
                    <span>Create </span>
                  </Link>
                </li>
                <li>
                  <Link to="/view-announcements">
                    <EventIcon />
                    <span>View All</span>
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <div
              onClick={() => toggleDropdown("examsystem")}
              className="dropdown-toggle"
            >
              <ClassIcon />
              <span>Exams System</span>
              {isEmsOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </div>
            {isExamOpen && (
              <ul className="dropdown-menu">
                <li>
                  <Link to="/examination-update">
                    <SchoolIcon />
                    <span>Create Examination</span>
                  </Link>
                </li>
                <li>
                  <Link to="/view-examination">
                    <VisibilityIcon />
                    <span>View Examination</span>
                  </Link>
                </li>
                <li>
                  <Link to="/view-cancel-examination">
                    <CancelIcon />
                    <span>Cancel Exams</span>
                  </Link>
                </li>
                <li>
                  <Link to="/student-marks-upload">
                    <AssessmentIcon />
                    <span>Upload Marks</span>
                  </Link>
                </li>
                <li>
                  <Link to="/view-student-marks">
                    <AssessmentIcon />
                    <span>View Student Marks</span>
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <div
              onClick={() => toggleDropdown("payroll")}
              className="dropdown-toggle"
            >
              <AccountBalanceWalletIcon />
              <span>Payroll</span>
              {isPayrollOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </div>
            {isPayrollOpen && (
              <ul className="dropdown-menu">
                <li>
                  <Link to="/create-bill">
                    <ReceiptLongIcon />
                    <span>Generate Bill</span>
                  </Link>
                </li>
                <li>
                  <Link to="/payment-records">
                    <HistoryIcon />
                    <span>Payment Records</span>
                  </Link>
                </li>
                <li>
                  <Link to="/add-bill-details">
                    <FormatListBulletedIcon />
                    <span>Add Bill Details</span>
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <Link to="/manage-notes">
              <EventIcon />
              <span>Manage Notes</span>
            </Link>
          </li>
          <li>
            <Link to="/admin-view-reports">
              <ReportProblemIcon />
              <span>View Reports</span>
            </Link>
          </li>
          {hasHostelAccess && (
            <li>
              <div
                onClick={() => toggleDropdown("hostelServices")}
                className="dropdown-toggle"
              >
                <HotelIcon />
                <span>Hostel Services</span>
                {isHostelOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </div>
              {isHostelOpen && (
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/hostel-allotments">
                      <GroupIcon />
                      <span>Hostel Allotment</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/view-hostels">
                      <VisibilityIcon />
                      <span>View Hostel</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/hostel-attendance">
                      <AccessTimeIcon />
                      <span>Hostel Attendance</span>
                    </Link>
                  </li>
                </ul>
              )}
            </li>
          )}
          <li>
            <Link to="/admin-customer-support">
              <HelpOutlineIcon />
              <span>Support</span>
            </Link>
          </li>
        </>
      );
    }

    if (role === "faculty") {
      return (
        <>
          <li style={{ marginTop: "0px" }}>
            <Link to="/faculty">
              <DashboardIcon />
              <span>Dashboard</span>
            </Link>
          </li>
          <li>
            <div
              onClick={() => toggleDropdown("Facultyattendance")}
              className="dropdown-toggle"
            >
              <EventAvailableIcon />
              <span>Attendance</span>
              {isFacultyAttendanceOpen ? (
                <ExpandLessIcon />
              ) : (
                <ExpandMoreIcon />
              )}
            </div>
            {isFacultyAttendanceOpen && (
              <ul className="dropdown-menu">
                <li>
                  <Link to="/class-attendance">
                    <GroupIcon />
                    <span>Class Attendance</span>
                  </Link>
                </li>
                <li>
                  <Link to="/student-attendance-history">
                    <CheckCircleIcon />
                    <span>Students History</span>
                  </Link>
                </li>
                <li>
                  <Link to="/faculty-attendance-history">
                    <EventIcon />
                    <span>User Attendance</span>
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <div
              onClick={() => toggleDropdown("Ems")}
              className="dropdown-toggle"
            >
              <ClassIcon />
              <span>Manage Exams</span>
              {isEmsOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </div>
            {isEmsOpen && (
              <ul className="dropdown-menu">
                <li>
                  <Link to="/faculty-create-examination">
                    <SchoolIcon />
                    <span>Create Examination</span>
                  </Link>
                </li>
                <li>
                  <Link to="/view-student-examination">
                    <AssessmentIcon />
                    <span>View Examination</span>
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <div
              onClick={() => toggleDropdown("MangeLeave")}
              className="dropdown-toggle"
            >
              <EventIcon />
              <span>Manage Leaves</span>
              {isMangeLeaveOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </div>
            {isMangeLeaveOpen && (
              <ul className="dropdown-menu">
                <li>
                  <Link to="/faculty-leave-apply">
                    <AnnouncementIcon />
                    <span>Leave Apply</span>
                  </Link>
                </li>
                <li>
                  <Link to="/faculty-leaves-history">
                    <EventIcon />
                    <span>Leave History</span>
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <Link to="/view-faculty-announcements">
              <AnnouncementIcon />
              <span>Announcements</span>
            </Link>
          </li>
          <li>
            <Link to="/faculty-share-notes">
              <EventIcon />
              <span>Share Notes</span>
            </Link>
          </li>
          <li>
            <Link to="/faculty-reports">
              <ReportProblemIcon />
              <span>Report</span>
            </Link>
          </li>
          <li>
            <Link to="/customer-support">
              <HelpOutlineIcon />
              <span>Support</span>
            </Link>
          </li>
        </>
      );
    }

    if (role === "student") {
      return (
        <>
          <li style={{ marginTop: "0px" }}>
            <Link to="/student">
              <DashboardIcon />
              <span>Dashboard</span>
            </Link>
          </li>
          <li>
            <Link to="/student-classes-subjects">
              <EventBusyIcon />
              <span>View classes</span>
            </Link>
          </li>
          <li>
            <Link to="/view-student-attendance">
              <EventAvailableIcon />
              <span>View Attendance</span>
            </Link>
          </li>
          <li>
            <div
              onClick={() => toggleDropdown("studentLeaves")}
              className="dropdown-toggle"
            >
              <AnnouncementIcon />
              <span>Manage Leaves</span>
              {isStudentLeavesOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </div>
            {isStudentLeavesOpen && (
              <ul className="dropdown-menu">
                <li>
                  <Link to="/student-leaves-apply">
                    <AnnouncementIcon />
                    <span>Leave Apply</span>
                  </Link>
                </li>
                <li>
                  <Link to="/student-leaves-history">
                    <EventIcon />
                    <span>Leaves History</span>
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <div
              onClick={() => toggleDropdown("studentems")}
              className="dropdown-toggle"
            >
              <EventIcon />
              <span>Exams System</span>
              {isStudentemsOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </div>
            {isStudentemsOpen && (
              <ul className="dropdown-menu">
                <li>
                  <Link to="/student-exams">
                    <AnnouncementIcon />
                    <span>Exams</span>
                  </Link>
                </li>
                <li>
                  <Link to="/student-view-marks">
                    <EventIcon />
                    <span>View Marks</span>
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <Link to="/view-student-announcements">
              <AnnouncementIcon />
              <span>Announcements</span>
            </Link>
          </li>
          <li>
            <Link to="/student-notes">
              <EventIcon />
              <span>Download Notes</span>
            </Link>
          </li>
          <li>
            <Link to="/fee-transaction">
              <EventIcon />
              <span>Fee Transaction</span>
            </Link>
          </li>
          {hasHostelAccess && (
            <li>
              <Link to="/student-hostel">
                <HotelIcon />
                <span>Hostel</span>
              </Link>
            </li>
          )}
          <li>
            <Link to="/student-reports">
              <ReportProblemIcon />
              <span>Report</span>
            </Link>
          </li>
          <li>
            <Link to="/student-customer-support">
              <HelpOutlineIcon />
              <span>Support</span>
            </Link>
          </li>
        </>
      );
    }

    return null;
  };

  return (
    <>
      <div className="sidebar">
        <ul className="sidebar-menu">
          {renderSidebarContent()}
          <li style={{ marginBottom: "80px" }}>
            <button
              onClick={() => setShowModal(true)}
              className="logout-button"
            >
              <LogoutIcon />
              <span>Logout</span>
            </button>
          </li>
        </ul>
      </div>

      {showModal && (
        <div className="modal-overlay-logout">
          <div className="modal">
            <p>Are you sure you want to logout?</p>
            <button onClick={handleLogout} className="yes_btn">
              Yes
            </button>
            <button
              onClick={() => setShowModal(false)}
              className="cancel_logout"
            >
              No
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default Sidebar;
